<template>
    <!-- 暂时的办法是 comHome 宽度设置102% 这里父亲容器加  overflow-x: hidden;-->
    <div style="height: 890px; width: 102%; position: relative">
        <div style="width: 34%; float: left; height: 100%">
            <comLeftTable :key="reloadTimer"></comLeftTable>
        </div>
        <div style="width: 65%; float: right; height: 100%">
            <comRightMap
                @reloadComponents="reloadComponents"
                :key="reloadTimer"
            ></comRightMap>
        </div>
    </div>
</template>
<script>
import comLeftTable from '@/V3/Main/ExportData/comLeftTable'
import comRightMap from '@/V3/Main/ExportData/comRightMap'

export default {
    data() {
        return {
            reloadTimer: '',
        }
    },
    methods: {
        reloadComponents() {
            this.reloadTimer = new Date().getTime()
        },
    },
    components: {
        comLeftTable,
        comRightMap,
    },
}
</script>


// WEBPACK FOOTER //
// src/V3/Main/comExportData.vue